import { type SVGProps } from "react";

export const VisaIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    {...props}
  >
    <path
      d="M15.6282 8.01233C13.9258 8.01233 12.4044 8.91822 12.4044 10.5919C12.4044 12.5113 15.1026 12.6439 15.1026 13.6082C15.1026 14.0142 14.6494 14.3776 13.8753 14.3776C12.7767 14.3776 11.9557 13.8698 11.9557 13.8698L11.6044 15.5587C11.6044 15.5587 12.5502 15.9877 13.806 15.9877C15.6672 15.9877 17.1318 15.0373 17.1318 13.335C17.1318 11.3068 14.4224 11.1782 14.4224 10.2832C14.4224 9.96512 14.7945 9.61663 15.5663 9.61663C16.4372 9.61663 17.1477 9.98597 17.1477 9.98597L17.4916 8.35473C17.4916 8.35473 16.7184 8.01233 15.6282 8.01233ZM0.0529404 8.13544L0.0117188 8.38167C0.0117188 8.38167 0.727917 8.51623 1.37297 8.78467C2.20353 9.09248 2.26269 9.27167 2.40257 9.82823L3.92684 15.8607H5.97012L9.11795 8.13544H7.07935L5.05668 13.3879L4.23131 8.93567C4.15562 8.42612 3.77221 8.13544 3.30289 8.13544H0.0529404ZM9.9377 8.13544L8.33849 15.8607H10.2825L11.8761 8.13544H9.9377ZM20.7799 8.13544C20.3112 8.13544 20.0628 8.39309 19.8805 8.84334L17.0325 15.8607H19.0711L19.4655 14.6912H21.9491L22.189 15.8607H23.9877L22.4185 8.13544H20.7799ZM21.0451 10.2226L21.6493 13.1215H20.0304L21.0451 10.2226Z"
      fill="#1434CB"
    />
  </svg>
);
